<template>
  <div>
    <v-btn
      v-if="circle"
      outline
      :loading="loading"
      :disabled="loading"
      small
      fab
      color="primary"
      @click="onExportCustomer"
      v-tooltip.top="$t('Print A4')"
    >
      <span class="fa fa-print"></span>
    </v-btn>
    <v-btn
      v-else
      :loading="loading"
      :disabled="loading || orders.length == 0"
      outline
      color="grey"
      @click="onExportCustomer"
    >
      <v-icon>fa fa-print</v-icon>
      &nbsp;{{ $t('Print A4') }}
    </v-btn>
    <v-dialog v-model="showEditAddress" width="800">
      <v-card v-if="showEditAddress">
        <v-card-text>
          <div style="text-align: right">
            <v-btn @click="cancelEdit" icon>
              <v-icon>close</v-icon>
            </v-btn>
          </div>
          <label for="pageAddress">{{ $t('Shop Address') }}</label>

          <shipping-address></shipping-address>
          <div class=" text-xs-center mt-3">
            <v-btn @click="skipEdit" outline color="grey">{{ $t('skip') }}</v-btn>
            <v-btn
              @click="saveContent"
              :loading="loadingsave"
              depressed
              color="primary"
              :disabled="!addresses || addresses.length == 0"
            >
              {{ $t('Save') }}
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showExport" persistent max-width="800" scrollable>
      <v-card>
        <div class="text-xs-right">
          <v-btn fab flat small @click="showExport = false"><v-icon>close</v-icon></v-btn>
        </div>
        <v-divider></v-divider>
        <v-card-text style="max-height: 600px">
          <v-layout wrap>
            <template v-for="page in exportpagecount">
              <v-flex xs6 sm4 md3 :key="`expor_${page}`" class="pa-2">
                <div class="z-border-red text-xs-center py-3">
                  <v-icon x-large> folder_shared </v-icon>
                  <div class="caption">
                    {{ ((page - 1) * exportlimit + 1) | numberFormat }} -
                    <template v-if="page == exportpagecount">
                      {{ orders.length | numberFormat }}
                    </template>
                    <template v-else>
                      {{ (page * exportlimit) | numberFormat }}
                    </template>
                  </div>
                  <v-progress-circular
                    v-if="loadingarr[page]"
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                  <v-btn v-else small color="primary" depressed @click="getShopProfile('a4', page)"
                    >download</v-btn
                  >
                </div>
              </v-flex>
            </template>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import PrintAllCovers from './PrintAllCovers.js'
import numeral from 'numeral'
export default {
  mixins: [PrintAllCovers],
  methods: {
    async formatTemplate(orders, page) {
      this.$set(this.loadingarr, page, false)
      var shippinglist = this.$store.state.shippinglist
      var vm = this

      var shippingtypeimg = await this.myShippingImg()
      var data = orders.map((el, i) => {
        var productdetail
        var qrimage = {}
        if (el.note && el.note.includes('base64,')) {
          qrimage = {
            margin: [20, 20, 0, 0],
            image: el.note,
            width: '220',
            alignment: 'left'
          }
        } else {
          qrimage = {
            text: '',
            width: 0
          }
        }
        var payment = vm.$t('Credit card')
        if (el.payment == 'banktransfer' || el.payment == 'transfer') {
          payment = vm.$t('Bank Transfer')
        } else if (el.payment == 'qrcode') {
          payment = 'Qr Code'
        } else if (el.payment == 'fbpay') {
          payment = vm.$t('Mobile Banking')
        } else if (el.payment == 'cod') {
          payment = vm.$t('cod_charge')
        }

        var formatproductdetail = []
        try {
          productdetail = JSON.parse(el.productdetail)
          formatproductdetail = productdetail.map((val, i) => {
            return [
              {
                text: val.name + ` x ${val.quantity} (${val.option})`,
                style: { fontSize: vm.regularsize },
                bold: true
              },
              {
                text: numeral(val.price).format('0,0.00'),
                style: { fontSize: vm.regularsize },
                alignment: 'right'
              }
            ]
          })
        } catch (error) {
          productdetail = []
          formatproductdetail = [{ text: el.productdetail }]
        }
        formatproductdetail.push(
          [
            { text: 'ค่าขนส่ง', style: { fontSize: vm.regularsize }, bold: true },
            {
              text: numeral(el.shippingcharge).format('0,0.00'),
              style: { fontSize: vm.regularsize },
              alignment: 'right'
            }
          ],
          [
            { text: 'ยอดรวม', style: { fontSize: vm.regularsize }, bold: true },
            {
              text: numeral(el.total).format('0,0.00'),
              style: { fontSize: vm.regularsize },
              alignment: 'right'
            }
          ],
          [
            { text: 'ส่วนลด', style: { fontSize: vm.regularsize }, bold: true },
            {
              text: numeral(el.discount).format('0,0.00'),
              style: { fontSize: vm.regularsize },
              alignment: 'right'
            }
          ],
          [
            { text: 'ยอดรวมทั้งสิ้น', style: { fontSize: vm.regularsize }, bold: true },
            {
              text: numeral(el.amount).format('0,0.00'),
              style: { fontSize: vm.regularsize },
              alignment: 'right'
            }
          ]
        )
        return [
          {
            // width: 225,
            table: {
              widths: ['*'],
              heights: [60],
              body: [
                [
                  {
                    text: [
                      { text: vm.$t('Sender') + '\n', style: 'header' },
                      {
                        text: `${vm.profile.companyname ? vm.profile.companyname + ', ' : ''}${
                          vm.profile.phoneno ? 'Tel. ' + vm.profile.phoneno + ', ' : ''
                        } ${vm.noSpaceAndSpecial(vm.profile.pageaddress)}`,
                        style: 'paragraph',
                        bold: true
                      }
                    ],
                    style: 'container',
                    lineHeight: 1
                  }
                ]
              ]
            }
          },
          {
            margin: [0, 6, 0, 0],
            table: {
              widths: ['*'],
              heights: [60],
              body: [
                [
                  {
                    text: [
                      { text: vm.$t('Receiver') + '\n', style: 'header' },
                      {
                        text: vm.noSpaceAndSpecial(el.nameaddress, true),
                        style: 'paragraph',
                        bold: true
                      }
                    ],
                    style: 'container'
                  }
                ]
              ]
            }
          },
          {
            columns: [
              {
                width: 320,
                stack: [
                  {
                    text: vm.$t('ใบกำกับภาษี/ใบเสร็จรับเงิน'),
                    style: 'receipt'
                  },
                  {
                    table: {
                      widths: [140, 150],
                      lineHeight: 0.5,
                      body: [
                        [
                          vm.$t('Order Date'),
                          {
                            text: dayjs(el.timestamp).format('DD/MM/YYYY HH:mm'),
                            style: { alignment: 'right' }
                          }
                        ],
                        [vm.$t('Order No.'), { text: el.id, style: { alignment: 'right' } }],
                        [
                          vm.$t('Shipping option'),
                          { text: vm.$t(el.shippingtype), style: { alignment: 'right' } }
                        ],
                        [
                          vm.$t('Payment Method'),
                          {
                            text: payment + ' - ' + vm.$t(el.transactionid),
                            style: { alignment: 'right' }
                          }
                        ]
                      ]
                    },
                    layout: {
                      hLineColor: function(i, node) {
                        return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
                      },
                      vLineColor: function(i, node) {
                        return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
                      },
                      vLineWidth: function(i, node) {
                        return 0
                      },
                      hLineWidth: function(i, node) {
                        return 0
                      }
                    }
                  },
                  {
                    table: {
                      widths: [140, 150],
                      body: [
                        [
                          {
                            text: vm.$t('Shipping option'),
                            style: { fontSize: vm.regularsize },
                            bold: true
                          },
                          {
                            columns: [
                              {
                                text: vm.$t(
                                  el.shippingtype.includes('other')
                                    ? shippinglist[el.shippingtype][4]
                                    : el.shippingtype
                                ),
                                width: '*',
                                style: { alignment: 'right', fontSize: vm.regularsize },
                                margin: [0, 0, 10, 0],
                                bold: true
                              },
                              {
                                image: shippingtypeimg[el.shippingtype]
                                  ? shippingtypeimg[el.shippingtype]
                                  : shippingtypeimg['other_charge'],
                                width: 30,
                                style: { alignment: 'right', fontSize: vm.regularsize - 3 }
                              }
                            ]
                          }
                        ],
                        [
                          {
                            text: vm.$t('Payment Method'),
                            style: { fontSize: vm.regularsize },
                            bold: true
                          },
                          {
                            text: payment,
                            style: { alignment: 'right', fontSize: vm.regularsize },
                            bold: true
                          }
                        ],
                        [
                          {
                            text: vm.$t('Remark'),
                            style: { fontSize: vm.regularsize },
                            bold: true
                          },
                          {
                            text: el.remark != null ? el.remark.split(';;')[0] : el.remark,
                            style: { alignment: 'right', fontSize: vm.regularsize },
                            bold: true
                          }
                        ]
                      ]
                    },
                    layout: {
                      hLineColor: function(i, node) {
                        return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
                      },
                      vLineColor: function(i, node) {
                        return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
                      },
                      vLineWidth: function(i, node) {
                        return 0
                      },
                      hLineWidth: function(i, node) {
                        return 0
                      }
                    }
                  },
                  {
                    text: vm.$t('Product Detail'),
                    margin: [0, 5, 0, 2],
                    style: {
                      bold: true,
                      fontSize: vm.headersize
                    }
                  },
                  {
                    table: {
                      widths: [230, 70],
                      body: formatproductdetail
                    },
                    layout: {
                      hLineColor: function(i, node) {
                        return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
                      },
                      vLineColor: function(i, node) {
                        return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
                      }
                    },
                    pageBreak: i + 1 == orders.length || el.payment == 'cod' ? '' : 'after'
                  },
                  ...(el.payment != 'cod'
                    ? []
                    : [
                        {
                          pageBreak: i + 1 == orders.length ? '' : 'after',
                          margin: [0, 10, 0, 0],
                          table: {
                            widths: [200 + 175],
                            body: [
                              // [vm.$t('Subtotal') + ':', { text: '฿' + el.total, style: { alignment: 'right' } }],
                              [
                                // { text: , style: { fontSize: vm.regularsize } },
                                {
                                  text: vm.$t('Total price') + ': ' + '฿' + el.amount,
                                  style: { alignment: 'right', fontSize: vm.regularsize + 2 },
                                  bold: true
                                }
                              ]
                            ]
                          },
                          layout: {
                            vLineWidth: function(i, node) {
                              return 0
                            },
                            hLineWidth: function(i, node) {
                              return 0
                            }
                          }
                        }
                      ])
                ]
              },
              {
                ...qrimage
              }
            ]
          }
        ]
      })

      return data
    },
    async printPDF(orders, pageSetting = {}, page) {
      var data = await this.formatTemplate(orders, page)
      var dd = {
        content: [data],
        pageSize: 'A4',
        pageMargins: [15, 15, 15, 15],
        styles: {
          header: {
            fontSize: this.headersize,
            color: '#ff5656',
            bold: true
          },
          paragraph: {
            fontWeight: 200,
            fontSize: this.regularsize
          },
          container: {
            margin: [2, 2, 2, 2]
          },
          receipt: {
            fontSize: this.headersize,
            color: '#ff5656',
            bold: true
          }
        },
        defaultStyle: {
          font: 'THSarabunNew'
        }
      }
      this.loading = false
      pdfMake.createPdf(dd).open()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/PrintAllCoversMonobo.vue